import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    $(this.element).modal('show');
  }

  disconnect() {
    $(this.element).modal('hide');

    // Quando o turbo-stream substitui o frame, o elemento .modal sai do DOM
    // antes do Bootstrap conseguir disparar hide.bs.modal. O handler em
    // entrypoints/.../modal-stack.js que decrementa body.dataset.openModals
    // nunca roda, e o body fica preso com modal-open + scroll travado.
    // Forçamos a limpeza recontando o que ainda está aberto no DOM.
    const body = document.body;
    const remainingOpen = document.querySelectorAll('.modal.fv-modal-stack').length;
    body.dataset.openModals = remainingOpen;
    if (remainingOpen === 0) {
      body.classList.remove('modal-open');
      body.style.removeProperty('padding-right');
      document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    }
  }
}